// external link warning////
$(document).ready(function () {
  const currentHost = window.location.hostname.replace("www.", "");
  const warningText =
    " Redirecting to a third-party website (opens in a new tab).";

  $('a[href^="http://"], a[href^="https://"]').each(function () {
    const $link = $(this);
    const linkHost = this.hostname.replace("www.", "");

    if (linkHost === currentHost || !linkHost) return;

    let linkText = $link.text().trim();
    if (!linkText) {
      const imgAlt = $link.find("img").attr("alt");
      linkText = imgAlt ? imgAlt.trim() : "this link";
    }

    const currentAriaLabel = $link.attr("aria-label");
    const newLabel = currentAriaLabel
      ? `${currentAriaLabel}${warningText}`
      : `${linkText}${warningText}`;

    $link.attr({
      "aria-label": newLabel,
      title: newLabel,
      target: "_blank",
      rel: "noopener noreferrer nofollow",
    });

    $link.addClass("external-link");
  });
});

// email address for cms//
$(document).ready(function () {
  $('a[href^="mailto:"]').each(function () {
    if (!$(this).attr("aria-label")) {
      const emailText = $(this).text().trim();
      $(this).attr("aria-label", "Email address " + emailText);
    }
  });
});

// phone number for cms//
$(document).ready(function () {
  $('a[href^="tel:"]').each(function () {
    if (!$(this).attr("aria-label")) {
      const phoneText = $(this).text().trim();
      $(this).attr("aria-label", "phone number " + phoneText);
    }
  });
});

$(document).ready(function () {
  $(".header__inline-menu .list-menu li.list-menu__has-mega").on(
    "click keypress",
    function (e) {
      e.stopPropagation();
      if (e.type === "keypress" && e.which !== 13) {
        return;
      }
      const dropdown = $(this).find("a").first();
      if (dropdown.attr("aria-expanded") === "false") {
        $("li.list-menu__has-mega > a").attr("aria-expanded", "false");
        $("li.list-menu__has-mega").removeClass("active");
        dropdown.attr("aria-expanded", "true");
        $(this).addClass("active");
      } else {
        dropdown.attr("aria-expanded", "false");
        $(this).removeClass("active");
      }
    }
  );
  let lastFocusedMenuTrigger = null;
  $(".header__inline-menu .list-menu li.list-menu__has-mega > a").on(
    "click",
    function (e) {
      lastFocusedMenuTrigger = $(this);
    }
  );

  $(document).on("keydown", function (e) {
    if (
      e.key === "Escape" &&
      $(".header__inline-menu .list-menu li.list-menu__has-mega.active")
        .length > 0
    ) {
      $("li.list-menu__has-mega > a").attr("aria-expanded", "false");
      $("li.list-menu__has-mega").removeClass("active");
      if (lastFocusedMenuTrigger) {
        lastFocusedMenuTrigger.focus();
      }
    }
  });
});

// mobile menu accessibility/////
$(document).ready(function () {
  const $menuDrawer = $(".gradient.menu-drawer.motion-reduce");
  const $menuButton = $(
    ".header__icon.header__icon--menu.header__icon--summary.link.focus-inset"
  );
  const $closeBtn = $(".myclose");

  $closeBtn.on("click", function () {
    $menuDrawer.removeClass("active").attr("aria-hidden", "true");
    $menuButton.focus();
  });

  $menuButton.on("click", function () {
    $menuDrawer.addClass("active").attr("aria-hidden", "false");

    $menuDrawer
      .find('a, button, input, [tabindex]:not([tabindex="-1"])')
      .first()
      .focus();
  });
});

// search focus /////
$(document).ready(function () {
  $(".header__search").on("click", function () {
    $(".close-drawer-btn").focus();
  });
});

// product description text size change////
$(document).ready(function () {
  $(".product__description h3").each(function () {
    var text = $(this).html();

    $(this).replaceWith(
      '<h2 style="font-weight: 500; color: rgb(51, 51, 51); font-size: 31px; line-height: 39px;">' +
        text +
        "</h2>"
    );
  });
});

// home removing////
$(document).ready(function () {
  $(".image-with-text-overlay__buttons a").each(function () {
    $(this).removeAttr("target");

    $(this).attr(
      "aria-label",
      $(this)
        .attr("aria-label")
        ?.replace(/\s*\(this link will open in new tab\)/i, "")
    );
    $(this).attr(
      "title",
      $(this)
        .attr("title")
        ?.replace(/\s*\(this link will open in new tab\)/i, "")
    );
  });
});
$(document).ready(function () {
  $(".featured-blog-post__text-item").each(function () {
    var blogTitle = $(this)
      .find(".featured-blog-post-card__heading a")
      .text()
      .trim();

    var viewBtn = $(this).find("a.btn.btn-primary");

    if (blogTitle && viewBtn.length) {
      viewBtn.attr("aria-label", "View details for " + blogTitle);
    }
  });

  function updateViewDetailsButtons() {
    $(".article-card-wrapper").each(function () {
      var blogTitle = $(this).find(".article-card__heading a").text().trim();

      var viewBtn = $(this).find("a.btn.btn-underlined");

      if (blogTitle && viewBtn.length) {
        viewBtn.attr("aria-label", "View details for " + blogTitle);
      }
    });
  }

  $(document).ready(function () {
    // Run on page load
    updateViewDetailsButtons();
  });
});

$(document).ready(function () {
  $(".view-mode__button").attr("aria-expanded", "true");

  $(".view-mode__button").on("click", function (event) {
    event.preventDefault();

    $(".view-mode__button")
      .removeClass("is-active")
      .attr("aria-expanded", "false");

    $(this).addClass("is-active").attr("aria-expanded", "true");
  });
});

$(document).ready(function () {
  const titleText = $(".article-template__title h1, .article-template__title")
    .first()
    .text()
    .trim();

  if (titleText) {
    $("article").attr("aria-label", titleText);
  }
});

$(document).ready(function () {
  $("br").attr("aria-hidden", "true");
});

$(document).ready(function () {
  $("#slideshow-template--25897964110130__slideshow_x6xMXi-slide01")
    .removeAttr("role")
    .removeAttr("aria-roledescription")
    .removeAttr("aria-label");
});

var lastFocusedButton;
jQuery("modal-trigger.cursor-pointer").on("click", function () {
  lastFocusedButton = $(this);

  setTimeout(function () {
    jQuery("modal-drawer.modal-drawer").attr("tabindex", 0).focus();
  }, 1000);
});

jQuery("button.close-modal-drawer").on("click", function () {
  setTimeout(function () {
    if (lastFocusedButton) {
      lastFocusedButton.attr("tabindex", 0).focus();
    }
  }, 1000);
});

$(document).ready(function () {
  var $slides = $(".slides-wrapper .slide");
  var totalSlides = $slides.length;

  $slides.each(function (index) {
    $(this).attr("aria-label", "Slide " + (index + 1) + " of " + totalSlides);
  });
});
$(document).ready(function () {
  $(".modal").attr("aria-hidden", "true").hide();

  $(".open-modal-button").focus();
});

// $(document).ready(function () {
//   $(".footer-block__heading.h6").each(function () {
//     $(this).replaceWith(
//       '<h2 class="footer-block__heading h6">' + $(this).html() + "</h2>"
//     );
//   });
// });
